import './style.less';

export default function($log) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
  }

  function applyStockImages() {
    if (!vm.ngModel || !vm.ngModel.length) return;

    vm.ngModel.forEach(activity => {
      if (activity.productImageUrl) {
        return;
      }
      const num = getRandomInt(0, 40);

      activity.productImageUrl = `https://assets.prolaera.com/img/stock-images/stock-image-${num}.jpg`;
    });
  }

  function activate() {
    try {
      applyStockImages();
      $log.debug('Activities Cards Component Activated');
    } catch (e) {
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/activities/activityCards/controller.js